import React from "react";

const StatusComp = () => {
  return (
    <div className="sales-tool-root">
      <h1>StatusComp comp</h1>
    </div>
  );
};

export default StatusComp;